var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 75,
    height: 75,
    viewBox: "0 0 75 75",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M37.5 16.5628V66.6565C36.9688 66.6565 36.4062 66.5628 35.9688 66.3128L35.8438 66.2503C29.8438 62.969 19.375 59.5315 12.5938 58.6253L11.6875 58.5003C8.6875 58.1253 6.25 55.3128 6.25 52.3128V14.5628C6.25 10.844 9.28125 8.03153 13 8.34404C19.5625 8.87529 29.5 12.1878 35.0625 15.6565L35.8438 16.1253C36.3125 16.4065 36.9062 16.5628 37.5 16.5628Z",
    fill: "#F66962"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M68.75 14.5943V52.313C68.75 55.313 66.3125 58.1255 63.3125 58.5005L62.2812 58.6255C55.4688 59.5318 44.9688 63.0005 38.9688 66.313C38.5625 66.563 38.0625 66.6568 37.5 66.6568V16.563C38.0938 16.563 38.6875 16.4068 39.1562 16.1255L39.6875 15.7818C45.25 12.2818 55.2188 8.93802 61.7813 8.37552H61.9688C65.6875 8.06302 68.75 10.8443 68.75 14.5943Z",
    fill: "#F66962"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.2188 28.875H17.1875C15.9062 28.875 14.8438 27.8125 14.8438 26.5312C14.8438 25.25 15.9062 24.1875 17.1875 24.1875H24.2188C25.5 24.1875 26.5625 25.25 26.5625 26.5312C26.5625 27.8125 25.5 28.875 24.2188 28.875Z",
    fill: "#F66962"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M26.5625 38.25H17.1875C15.9062 38.25 14.8438 37.1875 14.8438 35.9062C14.8438 34.625 15.9062 33.5625 17.1875 33.5625H26.5625C27.8438 33.5625 28.9062 34.625 28.9062 35.9062C28.9062 37.1875 27.8438 38.25 26.5625 38.25Z",
    fill: "#F66962"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBook);
export default __webpack_public_path__ + "static/media/book.9fff2d47fcba9dd46db69e3c52481ce3.svg";
export { ForwardRef as ReactComponent };